// extracted by mini-css-extract-plugin
export default {"root":"AddSuperBatchModuleModal_root__7qut-"};